/* Languange ID */

var idFooter = {
  "footer.desc"         : "Platform pemasaran kreator yang Anda perlukan. Kami menciptakan platform yang menyederhanakan proses kampanye bagi pembuat konten, brand, dan agensi untuk berkolaborasi.",
};
  
export default idFooter;